import { createGlobalStyle } from 'styled-components'

import BODY from './body'
import MOBILE from './mobile'
import REACT_MODAL from './reactModal'

const GlobalStyle = createGlobalStyle`
  ${BODY}
  ${MOBILE}
  ${REACT_MODAL}
`

export default GlobalStyle
